module.exports = __webpack_public_path__ + "0ff3a8bc48662c9a644ef8c0d352afff.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/korolev_medium_italic-webfont.woff
// module id = 7zDQ
// module chunks = 0